import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class MeetingsList extends Component {
  render() {
    const { title, venue, startDate, endDate, onClick, id } = this.props;

    return (
      <div className="col-xs-12">
        <div className="thumbnail inner-thumbnail">
          <div className="caption" onClick={onClick}>
            <h4>
              <NavLink to={`/recent-minutes/${id}`}>{title}</NavLink>
            </h4>
            <p>
              <b>Venue: </b> <span>{venue}</span>
            </p>
          </div>
          <div className="thumbnail-footer">
            <div className="pull-left">
              <i className="fa fa-calendar" />
              &nbsp;&nbsp;
              <small>{`Start ${startDate}`}</small>
            </div>
            <div className="pull-right">
              <i className="fa fa-calendar" />
              &nbsp;&nbsp;
              <small>{`End ${endDate}`}</small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MeetingsList;
